
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.633 1.121l.036.001h3.476c.102 0 .197.004.284.013l.143.475s.122.122.488.244c.198.099.36.055.467-.006a.539.539 0 01.021.128v2.256l.731.183s.122.305.183.549c.061.244-.914 0-.914 0v4.512l.304.549v2.5l-.243.366v.671c0 .548-.427.426-.427.426H4.877c-.488 0-.427-.304-.427-.304v-.793l-.305-.427v-2.439l.305-.549V5.025s-.915.244-.915-.183.915-.61.915-.61V2.098c0-.104.012-.197.034-.28a.48.48 0 00.515.036c.365-.122.487-.244.487-.244l.147-.489zm4.427 3.66l-.488 1.097v1.647l.488.183V4.781zm-5.061 0v2.927l.548-.183V5.817l-.548-1.036zm.121-.732l.61 1.646s.671-.122 1.769-.122c1.097 0 1.768.122 1.768.122l.732-1.646s-1.098-.244-2.439-.244c-1.342 0-2.44.244-2.44.244zm.348-2.474c-.015.014-.144.128-.487.243-.365.183-.609-.122-.609-.122.18-.72 1.245-.673 1.279-.729l-.182.607-.001.001zM9.403.956c.035.056 1.1.009 1.28.729 0 0-.244.305-.61.122-.366-.122-.488-.244-.488-.244l-.183-.61.001.003z"}})])
          )
        }
      }
    